import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/pro-regular-svg-icons';

type Props = {
  heading: string;
};

/**
 * What a search that found nothing shows in place of the listing.
 *
 * The same one sentence the legacy page had, with nothing around it to filter, sort or page.
 * Two things moved: it is the page's heading now, which the legacy page never had, and it is
 * the listing's own neutral panel rather than a red alert, because nothing went wrong — this
 * is the commonest thing a search does. The next try goes in the header's search box, which
 * the phone shows too.
 */
export default function NoResults({ heading }: Props) {
  return (
    <div className="rounded-xl border border-solid border-slate-200 bg-white px-5 py-12 text-center">
      <FontAwesomeIcon icon={faMagnifyingGlass} className="text-3xl text-slate-300" aria-hidden />
      <h1 className="m-0 mt-4 text-xl font-bold text-slate-900">{heading}</h1>
    </div>
  );
}
